// UX-048: the Billing page's usage-meter colour and money format, kept as plain
// functions so they can be tested without rendering the page.

/** Amber at 80% of the budget used; green below it. An unlimited plan has no budget to be near. */
export function usageMeterColor(usedUsd: number, monthlyUsd: number, unlimited: boolean): 'amber' | 'emerald' {
  if (unlimited || !(monthlyUsd > 0)) return 'emerald'
  return usedUsd > monthlyUsd * 0.8 ? 'amber' : 'emerald'
}

/** Money on this page is Australian dollars; the sign says so, so the caption does not have to. */
export function formatAud(amount: number): string {
  return `A$${amount.toFixed(2)}`
}
